module.exports = __webpack_public_path__ + "media/images/new/icons/mall-981565281216c8cf7dbc6549caaab080.gif";